import { Loader } from '@myosh/odin-components';

interface LoginLoaderProps {
  title?: string;
}

const LoginLoader = ({ title }: LoginLoaderProps) => {
  const loaderStyles = 'myl-mx-auto myl-flex myl-h-screen myl-w-full myl-flex-col myl-items-center myl-justify-center';
  return (
    <div className={loaderStyles}>
      <Loader title={title} />
    </div>
  );
};

export default LoginLoader;
